/**
 * KPI strip del tablero día — proto agenda-ux-v1 (.kpis):
 * Turnos hoy · Ocupación · Llegaron · No vinieron · En espera (I5).
 */
import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { agenda, agendaFonts } from '../domain/agendaTheme';
import type { DayBoardKpis } from '../domain/dayBoardLayout';

type Props = {
  kpis: DayBoardKpis;
  /** I5: cantidad en lista de espera — la celda aparece solo cuando llega el dato. */
  waitlistCount?: number | null;
  onPressWaitlist?: () => void;
};

export function AgendaDayKpis(props: Props) {
  const { kpis } = props;
  return (
    <View style={styles.row} accessibilityLabel="Resumen del día">
      <Cell label="Turnos hoy" value={String(kpis.total)} />
      <Cell label="Ocupación" value={kpis.occupancyPercent == null ? '—' : `${kpis.occupancyPercent}%`} />
      <Cell label="Llegaron" value={String(kpis.arrived)} />
      <Cell label="No vinieron" value={String(kpis.noShows)} warn={kpis.noShows > 0} />
      {props.waitlistCount != null ? (
        <Cell
          label="En espera"
          value={String(props.waitlistCount)}
          warn={props.waitlistCount > 0}
          onPress={props.onPressWaitlist}
        />
      ) : null}
    </View>
  );
}

function Cell(props: {
  label: string;
  value: string;
  warn?: boolean;
  onPress?: () => void;
}) {
  const inner = (
    <>
      <Text style={styles.label} numberOfLines={1}>
        {props.label}
      </Text>
      <Text style={[styles.value, props.warn && styles.valueWarn]}>{props.value}</Text>
    </>
  );
  if (props.onPress) {
    return (
      <TouchableOpacity
        style={styles.cell}
        onPress={props.onPress}
        activeOpacity={0.8}
        accessibilityRole="button"
        accessibilityLabel={`${props.label}: ${props.value}`}
      >
        {inner}
      </TouchableOpacity>
    );
  }
  return <View style={styles.cell}>{inner}</View>;
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    gap: 8,
    paddingHorizontal: 10,
    paddingVertical: 8,
    backgroundColor: agenda.bg,
  },
  cell: {
    flex: 1,
    minWidth: 0,
    backgroundColor: agenda.surface,
    borderWidth: 1,
    borderColor: agenda.border,
    borderRadius: 12,
    paddingHorizontal: 12,
    paddingVertical: 9,
    gap: 2,
  },
  label: {
    fontSize: 10.5,
    fontWeight: '700',
    color: agenda.ink2,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
    fontFamily: agendaFonts.sans,
  },
  value: {
    fontSize: 19,
    fontWeight: '700',
    color: agenda.ink,
    fontFamily: agendaFonts.sans,
    lineHeight: 22,
  },
  valueWarn: { color: agenda.noShow.text },
});
